<template>
  <div class="faqs">
    <div class="faqs-hero">
      <div class="faqs-hero-content">
        <div class="faqs-hero-title">FAQs</div>
        <div class="faqs-breadcrumb">
          <router-link to="/">Home</router-link>
          <span>/</span>
          <span>FAQs</span>
        </div>
      </div>
    </div>
    <div class="faqs-body">
      <div class="faqs-grid">
        <section ref="shoppingSection" class="faqs-section">
          <h2>SHOPPING INFORMATION</h2>
          <el-collapse v-model="activeShopping">
            <el-collapse-item
              v-for="item in shoppingFaqs"
              :key="item.id"
              :title="item.question"
              :name="item.id"
            >
              <div class="faqs-answer" v-html="item.answer"></div>
            </el-collapse-item>
          </el-collapse>
        </section>
        <section ref="returnSection" class="faqs-section">
          <h2>RETURN &amp; CANCELLATION INFORMATION</h2>
          <el-collapse v-model="activeReturn">
            <el-collapse-item
              v-for="item in returnFaqs"
              :key="item.id"
              :title="item.question"
              :name="item.id"
            >
              <div class="faqs-answer" v-html="item.answer"></div>
            </el-collapse-item>
          </el-collapse>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Faqs',
  data() {
    return {
      activeShopping: [],
      activeReturn: [],
      shoppingFaqs: [
        {
          id: 's1',
          question: 'How long does delivery take?',
          answer:
            '<p>Delivery time depends on your location:</p>' +
            '<ul>' +
            '<li>Metro Cities: 3–5 working days</li>' +
            '<li>Other Cities: 5–7 working days</li>' +
            '<li>Remote Areas: 7–10 working days</li>' +
            '</ul>' +
            '<p>You will receive a tracking link once your order is shipped.</p>'
        },
        {
          id: 's2',
          question: 'Do you offer free shipping?',
          answer:
            '<p>Yes, we offer free shipping on selected products and minimum order values. The final shipping charge will be shown at checkout.</p>'
        },
        {
          id: 's3',
          question: 'How can I track my order?',
          answer:
            '<p>Once dispatched, you will receive SMS/Email with a tracking ID.</p>' +
            '<p>You can also track it via:</p>' +
            '<p>My Account → Orders → Track Order</p>'
        },
        {
          id: 's4',
          question: 'What if my package is delayed?',
          answer:
            '<p>Delays may occur due to festivals, weather, or courier issues.</p>' +
            '<p>If your order is delayed over the expected timeline, contact us at:</p>' +
            '<p>📞 +91 8178059487</p>' +
            '<p>✉️ Thesosolutionpvt@gmail.com</p>'
        },
        {
          id: 's5',
          question: 'What should I do if my order arrives damaged?',
          answer:
            '<p>If your parcel arrives damaged or tampered:</p>' +
            '<ul>' +
            '<li>Record a parcel opening video</li>' +
            '<li>Contact support within 24 hours</li>' +
            '</ul>' +
            '<p>We will assist with replacement as per policy.</p>'
        },
        {
          id: 's6',
          question: 'What happens if I miss the delivery attempt?',
          answer:
            '<p>If you are unavailable during delivery, the courier partner will make 2–3 re-attempts.</p>' +
            '<p>You can also contact the courier using your tracking ID to schedule a convenient delivery time.</p>'
        }
      ],
      returnFaqs: [
        {
          id: 'r1',
          question: 'What is your return policy?',
          answer:
            '<p>We offer 7-day return/replacement for eligible products in case of:</p>' +
            '<ul>' +
            '<li>Wrong product delivered</li>' +
            '<li>Size issue (where applicable)</li>' +
            '<li>Damaged product</li>' +
            '</ul>' +
            '<p>Note: Items like socks, stockings, dupatta, scarf, and hygiene-sensitive items are non-returnable.</p>'
        },
        {
          id: 'r2',
          question: 'How do I initiate a return or replacement?',
          answer:
            '<p>Go to:</p>' +
            '<p>My Account → Orders → Request Return/Replace</p>' +
            '<p>Upload required photos/video and submit the request.</p>'
        },
        {
          id: 'r3',
          question: 'Are refunds available?',
          answer:
            '<p>Yes. Refunds are issued after QC approval:</p>' +
            '<ul>' +
            '<li>Prepaid orders: Refunded to original payment method</li>' +
            '<li>COD orders: Refunded via bank transfer or wallet credit</li>' +
            '</ul>' +
            '<p>Refund processing time: 5–7 working days</p>'
        },
        {
          id: 'r4',
          question: 'Can I cancel my order?',
          answer:
            '<p>You may cancel anytime before the order is shipped.</p>' +
            '<p>Once shipped, cancellations are not allowed.</p>'
        },
        {
          id: 'r5',
          question: 'How do I cancel my order?',
          answer:
            '<p>Go to:</p>' +
            '<p>My Account → Orders → Cancel Order</p>' +
            '<p>Or contact customer support immediately.</p>'
        },
        {
          id: 'r6',
          question: 'Can I change the delivery address after placing the order?',
          answer:
            '<p>Address changes are possible only before dispatch.</p>' +
            '<p>Contact us quickly through phone or email.</p>'
        },
        {
          id: 'r7',
          question: 'What if my return is rejected?',
          answer:
            '<p>A return may be rejected if:</p>' +
            '<ul>' +
            '<li>Product is used, washed, or altered</li>' +
            '<li>Tags/packaging are missing</li>' +
            '<li>Incorrect or incomplete proof is provided</li>' +
            '</ul>' +
            '<p>Ineligible returns will be shipped back to the customer.</p>'
        }
      ]
    }
  },
  created() {
    this.applySection()
  },
  watch: {
    $route() {
      this.applySection()
    }
  },
  methods: {
    applySection() {
      const section = this.$route.query.section
      if (section === 'shopping') {
        this.activeShopping = ['s1']
        this.activeReturn = []
        return
      }
      if (section === 'returns') {
        this.activeReturn = ['r1']
        this.activeShopping = []
      }
    }
  }
}
</script>

<style scoped>
.faqs {
  background: #f4f4f4;
  min-height: 100vh;
}
.faqs-hero {
  height: 220px;
  max-width: 1200px;
  margin: 24px auto 0;
  border-radius: 6px;
  background: url('/img/Untitled-design.webp') center / cover no-repeat;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.faqs-hero-content {
  width: 100%;
  padding: 0 32px;
}
.faqs-hero-title {
  font-size: 40px;
  font-weight: 700;
}
.faqs-breadcrumb {
  margin-top: 8px;
  font-size: 14px;
  display: flex;
  gap: 8px;
  align-items: center;
}
.faqs-breadcrumb a {
  color: #ffffff;
}
.faqs-body {
  width: 1200px;
  margin: 0 auto;
  padding: 40px 24px 80px;
}
.faqs-grid {
  background: #ffffff;
  padding: 32px;
  border-radius: 6px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 32px;
}
.faqs-section h2 {
  font-size: 16px;
  letter-spacing: 0.6px;
  color: #222222;
  margin-bottom: 16px;
}
.faqs-answer {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 1.6;
}
.faqs-answer p {
  margin: 0 0 10px;
}
.faqs-answer ul {
  margin: 0 0 12px 18px;
  padding: 0;
}
.faqs-answer li {
  margin-bottom: 6px;
}
@media (max-width: 1280px) {
  .faqs-hero {
    max-width: 100%;
    border-radius: 0;
    margin-top: 0;
  }
  .faqs-hero-content,
  .faqs-body {
    width: 100%;
  }
}
@media (max-width: 900px) {
  .faqs-grid {
    grid-template-columns: 1fr;
  }
}
</style>
